import * as Sentry from '@sentry/react';

interface UserData {
  id?: string;
  customerName?: string;
  email?: string;
}
interface Window {
  analytics: any;
}

declare let window: Window;

export const initializeSentry = () => {     
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_KEY || '',
        environment: process.env.REACT_APP_SENTRY_ENV,

        integrations: [
          Sentry.browserTracingIntegration(),
        ],
      
        // Set tracesSampleRate to 0.1 to capture 10%
        // of transactions for performance monitoring.
        tracesSampleRate: 0.05,
        profilesSampleRate: 0,
      
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      
        // Capture Replay for 0% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
    });
}

export const { ErrorBoundary } = Sentry;

export const notifyError = (error: string) => Sentry.captureException(new Error(error));
export const notifyErrorObject = (error: any) => Sentry.captureException(error);
export const notifyWithScopeObject = (error: Error, level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug') =>
  Sentry.withScope((scope) => {
    scope.setLevel(level);
    Sentry.captureException(error);
  });

export const trackEvent = (name: string, properties?: object) => window.analytics.track(name, properties);

export const setSentryUserProfile: (data: UserData) => void = (data) => {
  Sentry.setUser({
    id: data.id,
    username: data.customerName ?? 'Not Available',
    email: data.email,
  });
};

export const clearUserProfile = () => {
  Sentry.setUser(null);
};
